import { gql } from '@apollo/client';

export const UPDATE_PORTFOLIO_GOALS = gql`
  mutation UpdatePortfolioGoals($input: PortfolioGoalsInput!) {
    updatePortfolioGoals(input: $input) {
      success
      error
      goals {
        targetMultiple
        distLarge
        distMid
        distLow
        targetLarge
        targetMid
        targetLow
        createdAt
        updatedAt
      }
    }
  }
`;


